import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  WsFrameType_Text_getInstance1jd6oe7lrkrhj as WsFrameType_Text_getInstance,
  WsProtocol2u70gp1eq7nu9 as WsProtocol,
} from './WsProtocol.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ApolloNetworkException3denf70pfh242 as ApolloNetworkException } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  mutableMapOfk2y3zt1azl40 as mutableMapOf,
  mapOf1xd03cq9cnmy8 as mapOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { withTimeout3dbn27y1hxkws as withTimeout } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Timeout.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { Companion_instancegdssxde1x86b as Companion_instance } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/DefaultHttpRequestComposer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SubscriptionWsProtocol$Factory$_init_$slambda_1syt4bClass;
function SubscriptionWsProtocol$Factory$_init_$slambda_1syt4b() {
  if (SubscriptionWsProtocol$Factory$_init_$slambda_1syt4bClass === VOID) {
    class $ {
      *x6a($completion) {
        return null;
      }
      kd($completion) {
        return this.x6a($completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    SubscriptionWsProtocol$Factory$_init_$slambda_1syt4bClass = $;
  }
  return SubscriptionWsProtocol$Factory$_init_$slambda_1syt4bClass;
}
function SubscriptionWsProtocol$Factory$_init_$slambda_1syt4b_0() {
  var i = new (SubscriptionWsProtocol$Factory$_init_$slambda_1syt4b())();
  var l = ($completion) => i.x6a($completion);
  l.$arity = 0;
  return l;
}
var FactoryClass;
function Factory() {
  if (FactoryClass === VOID) {
    class $ {
      constructor(connectionAcknowledgeTimeoutMs, connectionPayload, frameType) {
        connectionAcknowledgeTimeoutMs = connectionAcknowledgeTimeoutMs === VOID ? 10000n : connectionAcknowledgeTimeoutMs;
        var tmp;
        if (connectionPayload === VOID) {
          tmp = SubscriptionWsProtocol$Factory$_init_$slambda_1syt4b_0();
        } else {
          tmp = connectionPayload;
        }
        connectionPayload = tmp;
        frameType = frameType === VOID ? WsFrameType_Text_getInstance() : frameType;
        this.y6a_1 = connectionAcknowledgeTimeoutMs;
        this.z6a_1 = connectionPayload;
        this.a6b_1 = frameType;
      }
      h1() {
        return 'graphql-ws';
      }
      b6b(webSocketConnection, listener, scope) {
        var tmp0_connectionPayload = this.z6a_1;
        var tmp1_connectionAcknowledgeTimeoutMs = this.y6a_1;
        var tmp2_frameType = this.a6b_1;
        return new (SubscriptionWsProtocol())(webSocketConnection, listener, tmp1_connectionAcknowledgeTimeoutMs, tmp0_connectionPayload, tmp2_frameType);
      }
    }
    initMetadataForClass($, 'Factory', Factory);
    FactoryClass = $;
  }
  return FactoryClass;
}
var SubscriptionWsProtocol$_init_$slambda_7z3jffClass;
function SubscriptionWsProtocol$_init_$slambda_7z3jff() {
  if (SubscriptionWsProtocol$_init_$slambda_7z3jffClass === VOID) {
    class $ {
      *x6a($completion) {
        return null;
      }
      kd($completion) {
        return this.x6a($completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    SubscriptionWsProtocol$_init_$slambda_7z3jffClass = $;
  }
  return SubscriptionWsProtocol$_init_$slambda_7z3jffClass;
}
function SubscriptionWsProtocol$_init_$slambda_7z3jff_0() {
  var i = new (SubscriptionWsProtocol$_init_$slambda_7z3jff())();
  var l = ($completion) => i.x6a($completion);
  l.$arity = 0;
  return l;
}
var SubscriptionWsProtocol$connectionInit$slambdaClass;
function SubscriptionWsProtocol$connectionInit$slambda() {
  if (SubscriptionWsProtocol$connectionInit$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.c6b_1 = this$0;
      }
      *r1f($this$withTimeout, $completion) {
        var map = yield* this.c6b_1.f6b($completion);
        var type = map.u4('type');
        if (equals(type, 'connection_ack'))
          return Unit_instance;
        else if (equals(type, 'connection_error'))
          throw ApolloNetworkException().t47('Connection error:\n' + toString_0(map));
        else {
          println("unknown message while waiting for connection_ack: '" + toString(type));
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.r1f((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    SubscriptionWsProtocol$connectionInit$slambdaClass = $;
  }
  return SubscriptionWsProtocol$connectionInit$slambdaClass;
}
function SubscriptionWsProtocol$connectionInit$slambda_0(this$0) {
  var i = new (SubscriptionWsProtocol$connectionInit$slambda())(this$0);
  var l = ($this$withTimeout, $completion) => i.r1f($this$withTimeout, $completion);
  l.$arity = 1;
  return l;
}
var SubscriptionWsProtocolClass;
function SubscriptionWsProtocol() {
  if (SubscriptionWsProtocolClass === VOID) {
    class $ extends WsProtocol() {
      constructor(webSocketConnection, listener, connectionAcknowledgeTimeoutMs, connectionPayload, frameType) {
        connectionAcknowledgeTimeoutMs = connectionAcknowledgeTimeoutMs === VOID ? 10000n : connectionAcknowledgeTimeoutMs;
        var tmp;
        if (connectionPayload === VOID) {
          tmp = SubscriptionWsProtocol$_init_$slambda_7z3jff_0();
        } else {
          tmp = connectionPayload;
        }
        connectionPayload = tmp;
        frameType = frameType === VOID ? WsFrameType_Text_getInstance() : frameType;
        super(webSocketConnection, listener);
        this.i6b_1 = connectionAcknowledgeTimeoutMs;
        this.j6b_1 = connectionPayload;
        this.k6b_1 = frameType;
      }
      *l6b($completion) {
        var message = mutableMapOf([to('type', 'connection_init')]);
        var payload = yield* this.j6b_1($completion);
        if (!(payload == null)) {
          message.x4('payload', payload);
        }
        this.m6b(message, this.k6b_1);
        yield* withTimeout(this.i6b_1, SubscriptionWsProtocol$connectionInit$slambda_0(this), $completion);
        return Unit_instance;
      }
      n6b(messageMap) {
        var tmp0_subject = messageMap.u4('type');
        if (equals(tmp0_subject, 'data')) {
          var tmp = messageMap.u4('id');
          var tmp_0 = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
          var tmp_1 = messageMap.u4('payload');
          this.e6b_1.r6b(tmp_0, (!(tmp_1 == null) ? isInterface(tmp_1, KtMap()) : false) ? tmp_1 : THROW_CCE());
        } else if (equals(tmp0_subject, 'error')) {
          var id = messageMap.u4('id');
          if (!(id == null) ? typeof id === 'string' : false) {
            var tmp_2 = messageMap.u4('payload');
            this.e6b_1.q6b(id, (tmp_2 == null ? true : isInterface(tmp_2, KtMap())) ? tmp_2 : THROW_CCE());
          } else {
            var tmp_3 = messageMap.u4('payload');
            this.e6b_1.p6b((tmp_3 == null ? true : isInterface(tmp_3, KtMap())) ? tmp_3 : THROW_CCE());
          }
        } else if (equals(tmp0_subject, 'complete')) {
          var tmp_4 = messageMap.u4('id');
          this.e6b_1.o6b((!(tmp_4 == null) ? typeof tmp_4 === 'string' : false) ? tmp_4 : THROW_CCE());
        }
      }
      s6b(request) {
        this.m6b(mapOf([to('type', 'start'), to('id', request.j43_1.toString()), to('payload', Companion_instance.q48(request))]), this.k6b_1);
      }
      t6b(request) {
        this.m6b(mapOf([to('type', 'stop'), to('id', request.j43_1.toString())]), this.k6b_1);
      }
    }
    initMetadataForClass($, 'SubscriptionWsProtocol', VOID, VOID, VOID, [0]);
    SubscriptionWsProtocolClass = $;
  }
  return SubscriptionWsProtocolClass;
}
//region block: exports
export {
  Factory as Factory2jyzsj2j7cj0z,
};
//endregion

//# sourceMappingURL=SubscriptionWsProtocol.mjs.map
